
import { Options, Vue } from 'vue-class-component';
import { IFormData } from '../../models/form-contact/form-contact.model';
import { store } from '../../store';
import { IFormModal } from '../../models/store/modals/form-modal.model';
import { Watch } from 'vue-property-decorator';
import { isEmpty, isEqual } from 'lodash';
import { IncomingEntity } from '../../models/entities/incoming-entity.model';
import { GoodType } from '../../models/entities/good-type.model';
import ViewData from '../../components/modals/ViewData.vue';
import { service } from '../../services/service';
import { ITire } from '../../models/store/tires/tire.model';
import { storageService } from '../../services/storage';
import { EmailType } from '../../enums/email-type.enum';
import { useRoute } from 'vue-router';
import { DEFAULT_GOOD_REST } from '../../constants/constants';
type QueryParType = { type: GoodType };

@Options({
    components: {
        ViewData,
    },
})
export default class FormModal extends Vue {
    route = useRoute();
    isMobile = false;
    isFirstSalePriceSet = false;
    disabledSubmitBtn = false;
    formLabel = 'Заказ';
    supportLabel = 'Поддержка';
    emailPattern = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/i;
    phonePattern = /^(29|25|44|33)(\d{3})(\d{2})(\d{2})$/;
    timeOut = 5000;
    sendFormData: IFormData = {
        type: EmailType.ON_CLICK_BUY,
        _id: '',
        goodType: 'tires',
        shopName: '',
        fullName: '',
        email: '',
        phone: '',
        city: '',
        countGoods: '',
        description: '',
        comment: '',
    };

    nameRules: unknown[] = [
        (value: string) => {
            return (value && (value || '').length >= 3) || 'введите имя';
        },
    ];

    emailRules: unknown[] = [
        (value: string) => {
            return value
                ? this.emailPattern.test(String(value)) || 'формат электронной почты'
                : '' || '';
        },
    ];

    phoneRules: unknown[] = [
        (value: string) => {
            return value
                ? this.phonePattern.test(String(value)) ||
                      'белорусский формат мобильного телефона ((29, 33, 44, 25)1234567)'
                : '' || '';
        },
    ];

    countRules: unknown[] = [
        (value: string) => {
            // remove simbol '>' from rest, SCREW
            let currentRest = (this.modal.data as IncomingEntity)?.rest as string;

            if (isEqual(this.sendFormData.goodType, 'screw'))
                currentRest = currentRest.includes('>')
                    ? '1' + currentRest.replace('>', '').trim() + '0'
                    : currentRest; //set 180

            currentRest =
                Number(currentRest) <= DEFAULT_GOOD_REST ? currentRest : `${DEFAULT_GOOD_REST}`;

            return currentRest
                ? (value && Number(value) - Number(currentRest) <= 0 && Number(value)) ||
                      `возможно вы указали не верное значение, значение число, не больше ${currentRest}`
                : '' || '';
        },
    ];

    validateInputNumbers: unknown[] = [
        (value: string) => {
            return (value && Number(value)) || 'Введите только число';
        },
    ];

    timeWheelsRules: unknown[] = [
        (v: string) => {
            return (Number(v) && Number(v) <= 10) || 'значение как число, не больше 10';
        },
    ];

    get modal(): IFormModal {
        return store.getters.getFormModal;
    }

    get responseStatus(): boolean {
        return store.getters.getResponseStatus;
    }

    get isActiveSaleEntity(): boolean {
        return !store.getters.getActiveEntitySaleIds.includes(
            (this.modal.data as IncomingEntity)?._id,
        );
    }

    get computedSalePrice(): string {
        return this.isActiveSaleEntity
            ? ((this.modal.data as IncomingEntity)?.salePrice as string)
            : (
                  Number((this.modal.data as IncomingEntity)?.salePrice) -
                  (Number((this.modal.data as IncomingEntity)?.saleValue) *
                      Number((this.modal.data as IncomingEntity)?.salePrice)) /
                      (isEqual(this.sendFormData.goodType, 'cargo') ? 100 : 1)
              ).toFixed(0);
    }

    get applicabilities(): string {
        return (this.modal?.data as IncomingEntity)?.applicabilities?.reduce(
            (prev: string, { value }) => {
                return (prev += ` ${value}`);
            },
            '',
        );
    }

    submitFunction(): void {
        if (
            !this.phonePattern.test(this.sendFormData.phone as string) ||
            !this.sendFormData.description ||
            (!this.modal.isSupport && !this.sendFormData.countGoods)
        ) {
            store.dispatch('changeSnackbar', {
                status: true,
                text: `Ошибка при заполнении формы${this.modal.isSupport ? '' : ' заказа'}`,
                isError: true,
            });
            return;
        }

        if (storageService.compareTime(this.sendFormData, 'formData')) return;

        if (!this.modal.isSupport) {
            this.sendFormData.shopName = (this.modal.data as IncomingEntity).typeName;
            this.sendFormData._id = (this.modal.data as IncomingEntity)._id;
        } else {
            this.sendFormData.type = EmailType.SUPPORT;
        }

        store.dispatch('submitEmailForm', this.sendFormData);
        this.disabledSubmitBtn = true;
    }

    closeModal(): void {
        store.dispatch('changeFormModal', { status: false, sale: false });
        this.clearFunction();
    }

    clearFunction(): void {
        this.sendFormData.fullName = '';
        this.sendFormData.city = '';
        this.sendFormData.email = '';
        this.sendFormData.phone = '';
        this.sendFormData.description = '';
        this.sendFormData.countGoods = '';
        this.sendFormData.shopName = '';
        this.sendFormData.comment = '';
    }

    setOrderDescription(goodType: GoodType, isClear?: boolean): void {
        let result = '';
        this.sendFormData.description = result;

        if (isClear) return;

        switch (goodType) {
            case 'cargo':
                {
                    result = `Название: ${(this.modal.data as IncomingEntity).name} ,
        цена со скидкой: ${
            !this.modal.sale
                ? (this.modal.data as IncomingEntity).salePrice
                : this.computedSalePrice
        } бел. руб.,
        --------------------
        цена: ${(this.modal.data as IncomingEntity).price} бел. руб.,
        --------------------
        применяемость: ${this.applicabilities}`;
                }
                break;
            case 'tires':
                {
                    if (!this.isFirstSalePriceSet) {
                        ({ ...(this.modal.viewData as ITire) }).salePrice = this.computedSalePrice;
                        this.isFirstSalePriceSet = true;
                    }

                    result = `Название: ${(this.modal.data as IncomingEntity).name} ,
        цена со скидкой: ${
            !this.modal.sale
                ? (this.modal.data as IncomingEntity).salePrice
                : this.computedSalePrice
        } бел. руб.,
        --------------------
        цена: ${(this.modal.data as IncomingEntity).price} бел. руб.,
        --------------------
        индекс: ${(this.modal.data as IncomingEntity).index}
        --------------------
        размер: ${(this.modal.data as IncomingEntity).size}`;
                }

                break;

            case 'wheels':
                result = `Название: ${(this.modal.data as IncomingEntity).brand} ${(this.modal.data as IncomingEntity).name}
        --------------------
        цена со скидкой: ${(this.modal.data as IncomingEntity).salePrice} руб,
        --------------------
        цена: ${(this.modal.data as IncomingEntity).price} руб,
        --------------------
        тип: ${(this.modal.data as IncomingEntity).wheelType},
        --------------------
        радиус: ${(this.modal.data as IncomingEntity).radius},
        --------------------
        ширина: ${(this.modal.data as IncomingEntity).width},
        --------------------
        pcd: ${(this.modal.data as IncomingEntity).pcd},
        --------------------
        et: ${(this.modal.data as IncomingEntity).et},
        --------------------
        dia: ${(this.modal.data as IncomingEntity).dia}`;
                break;

            case 'rings':
                result = `Производитель: ${(this.modal.data as IncomingEntity).typeName},
        --------------------
        цена со скидкой: ${(this.modal.data as IncomingEntity).salePrice} руб,
        --------------------
        цена: ${(this.modal.data as IncomingEntity).price} руб,
        --------------------
        внешний: ${(this.modal.data as IncomingEntity).external},
        --------------------
        внутренний${(this.modal.data as IncomingEntity).internal} руб`;

                break;

            case 'batteries':
                result = `Производитель: ${(this.modal.data as IncomingEntity).brand},
        --------------------
        название: ${(this.modal.data as IncomingEntity).name},
        --------------------
        цена со скидкой: ${(this.modal.data as IncomingEntity).salePrice} руб,
        --------------------
        цена: ${(this.modal.data as IncomingEntity).price} руб,
        --------------------
        емкость: ${(this.modal.data as IncomingEntity).volume},
        --------------------
        полярность: ${(this.modal.data as IncomingEntity).type ? 'прямая' : 'обратная'},
        --------------------
        пусковой ток: ${(this.modal.data as IncomingEntity).startingCurrent} A`;

                break;

            case 'screw':
                result = `Производитель: ${(this.modal.data as IncomingEntity).brand},
        --------------------
        название: ${(this.modal.data as IncomingEntity).name},
        --------------------
        цена со скидкой: ${(this.modal.data as IncomingEntity).salePrice} руб,
        --------------------
        цена: ${(this.modal.data as IncomingEntity).price} руб,
        --------------------
        детали: ${(this.modal.data as IncomingEntity).description},
        --------------------
        длина: ${(this.modal.data as IncomingEntity).length},
        --------------------
        ключ: ${(this.modal.data as IncomingEntity).wrench},
        --------------------
        резьба: ${(this.modal.data as IncomingEntity).thread},
        --------------------
        тип крепежа: ${(this.modal.data as IncomingEntity).fastenerType},
        --------------------
        цвет: ${(this.modal.data as IncomingEntity).color}`;

                break;

            case 'case':
                result = `Название: автокейс,
        --------------------
        тип: ${(this.modal.data as IncomingEntity).caseType}
        --------------------
        материал: ${(this.modal.data as IncomingEntity).materialType}
        -------------------
        цена со скидкой: ${(this.modal.data as IncomingEntity).salePrice} руб,
        --------------------
        цена: ${(this.modal.data as IncomingEntity).price} руб,
        --------------------
        цвет: ${(this.modal.data as IncomingEntity).color},
        --------------------
        размеры: ${(this.modal.data as IncomingEntity).length} * ${(this.modal.data as IncomingEntity).width} * ${(this.modal.data as IncomingEntity).height}`;

                break;

            case 'mat':
                result = this.modal.data as string;
                break;
        }

        result +=
            `${(this.modal.viewData as IncomingEntity).additions?.length ? '\n' + '---------' : ''}` +
            '\n' +
            `Общая цена: ${service.totalOrderPrice(this.modal.viewData as IncomingEntity, this.sendFormData.countGoods)}`;

        this.sendFormData.description = result;
    }

    setGoodType(route: string, queryParam: QueryParType): void {
        let result: GoodType = 'tires';

        if (queryParam.type) {
            result = queryParam.type;
        } else {
            switch (route) {
                case '/wheel-disks':
                    result = 'wheels';
                    break;

                case '/accumulator-batteries':
                    result = 'batteries';
                    break;

                case '/centering-rings':
                    result = 'rings';
                    break;

                case '/screw':
                    result = 'screw';
                    break;

                case '/auto-cases':
                    result = 'case';
                    break;

                case '/auto-mats':
                    result = 'mat';
                    break;

                case '/cargo-tires':
                    result = 'cargo';
                    break;
            }
        }

        this.sendFormData.goodType = result;
    }

    @Watch('modal')
    subscribeModalChange() {
        this.isMobile = store.getters.getIsMobile;
        this.setGoodType(this.route.path, this.route.query as QueryParType);

        if (!isEmpty(this.modal.data)) this.setOrderDescription(this.sendFormData.goodType);
    }

    @Watch('responseStatus')
    subscribeResponseFunction() {
        if (!this.responseStatus) {
            storageService.setLocalData(this.sendFormData);
            this.closeModal();
            this.setOrderDescription(this.sendFormData.goodType, true);
            this.disabledSubmitBtn = false;
        }
    }

    @Watch('sendFormData.countGoods')
    goodCountObservable(count: string): void {
        if (Number(count)) this.setOrderDescription(this.sendFormData.goodType);
    }
}
